module.exports = {
  lang: {
    t1: `Inicio`,
    t2: `Tarjeta de visita`,
    t3: `Seguir`,
    t4: `Contactos`,
    t5: `Mensajes`,
    t6: `Iniciar sesión`,
    t7: `Registrarse`,
    t8: `Nueva plataforma global de conectividad comercial, nuevo terreno para el marketing digital de las empresas`,
    t9: `WeMeet - Iniciar sesión con Número de Teléfono`,
    t10: `Número de teléfono móvil`,
    t11: `Código de verificación`,
    t12: `Por favor, ingrese su número de teléfono móvil`,
    t13: `Por favor, ingrese el código de verificación`,
    t14: `Obtener`,
    t15: `Iniciar sesión`,
    t16: `Por favor, ingrese el número de teléfono móvil en el formato correcto`,
    t17: `Código de verificación enviado`,
    t18: `Código de verificación incorrecto ingresado. Por favor, verifícalo e inténtalo nuevamente.`,
    t19: `Inicio de sesión exitoso`,
    t20: `Su código de verificación es (0). Por favor, utilícelo dentro de {1} minuto(s).`,
    t21: `Cancelar`,
    t22: `Confirmar`,
    t23: `Consejos útiles`,
    t24: `Su registro en la cuenta de WeMeet aún no está completo. Acción ahora para completar el proceso de registro y disfrutar de múltiples interacciones e infinitas posibilidades.`,
    t25: `Ir a registrarse`,
    t26: `Iniciar sesión en WeMeet por correo electrónico`,
    t27: `Nombre de la cuenta`,
    t28: `Introduce tu correo electrónico`,
    t29: `Contraseña`,
    t30: `Introduce tu contraseña`,
    t31: `¿Olvidaste tu contraseña?`,
    t32: `Iniciar sesión`,
    t33: `Otros métodos de inicio de sesión`,
    t34: `¿Ya está registrado en la aplicación mini WeMeet? Úsalo ahora.`,
    t35: `Iniciar sesión con número de teléfono`,
    t36: `Por favor, ingrese su correo electrónico primero.`,
    t37: `Por favor, ingrese su contraseña primero.`,
    t38: `El formato del correo electrónico es incorrecto`,
    t39: `Si ya tienes una cuenta en WeMeet, puedes iniciar sesión directamente`,
    t40: `Iniciar sesión`,
    t41: `Foto de perfil`,
    t42: `Por favor, sube una foto de perfil real`,
    t43: `Nombre completo`,
    t44: `Nombre`,
    t45: `Apellido`,
    t46: `Nombre de la organización`,
    t47: `Por favor, indique el nombre de su organización`,
    t48: `Cargo`,
    t49: `Por favor, indique el título de su cargo dentro de la organización`,
    t50: `Correo electrónico`,
    t51: `Introduce tu correo electrónico`,
    t52: `Número de teléfono móvil`,
    t53: `Por favor, ingrese su número de teléfono móvil`,
    t54: `Región`,
    t55: `Por favor, seleccione una región`,
    t56: `Zona`,
    t57: `Por favor, seleccione provincia, ciudad y distrito`,
    t58: `Dirección`,
    t59: `Por favor, indique su dirección`,
    t60: `He leído y acepto los`,
    t61: `Términos de Servicio`,
    t62: `Política de Privacidad`,
    t63: `Continuar`,
    t64: `Por favor, marque primero el acuerdo de usuario`,
    t65: `Por favor, indique su nombre`,
    t66: `Por favor, rellena tu apellido`,
    t67: `Por favor, rellena tu correo electrónico primero`,
    t68: `Por favor, rellena el nombre de tu organización primero`,
    t69: `El formato del correo electrónico es incorrecto`,
    t70: `Cancelar`,
    t71: `Completar`,
    t72: `Verificar número de móvil`,
    t73: `Número de teléfono móvil`,
    t74: `Código de verificación`,
    t75: `Por favor, ingrese el código de verificación`,
    t76: `Obtener`,
    t77: `Saltar verificación`,
    t78: `Enviar`,
    t79: `Verificado`,
    t80: `Código de verificación incorrecto ingresado. Por favor, verifícalo e inténtalo nuevamente.`,
    t81: `Saltado`,
    t82: `Consejos útiles`,
    t83: `El número de teléfono que ingresaste ya está registrado con una cuenta de WeMeet. No es necesario registrarse de nuevo, inicia sesión ahora mismo.`,
    t84: `Ir a inicio de sesión`,
    t85: `Consejos útiles`,
    t86: `El correo electrónico que ingresaste ya está registrado con una cuenta de WeMeet. No es necesario registrarse de nuevo, inicia sesión ahora mismo.`,
    t87: `Ir a inicio de sesión`,
    t88: `Se ha enviado un enlace de verificación.`,
    t89: `Por favor, revisa tu correo electrónico y haz clic en el enlace para completar el registro.`,
    t90: `Entendido`,
    t91: `¡Bienvenido a WeMeet!`,
    t92: `¡Bienvenido/a a WeMeet! Por favor, haga clic en el botón para completar el registro. Recuerda amablemente: este enlace es válido durante 24 horas, actúe lo antes posible.`,
    t93: `Completar registro`,
    t94: `Tu correo electrónico ha sido activado. Por favor, ingresa tu contraseña.`,
    t95: `Ingrese su contraseña`,
    t96: `Introduce tu contraseña`,
    t97: `Confirma tu contraseña`,
    t98: `Por favor, ingresa nuevamente tu contraseña`,
    t99: `Debe contener una combinación de letras mayúsculas y minúsculas, números y caracteres especiales, con una longitud entre 8 y 20 caracteres`,
    t100: `Introduce tu contraseña`,
    t101: `Por favor, ingresa nuevamente tu contraseña`,
    t102: `Las contraseñas no coinciden`,
    t103: `¡Felicidades por completar tu registro!`,
    t104: `Ya has iniciado sesión en WeMeet. Ahora puedes continuar con tus acciones anteriores.`,
    t105: `Continúa tu experiencia`,
    t106: `Consejos útiles`,
    t107: `El enlace ha caducado. Por favor, haz clic en el botón para obtenerlo de nuevo.`,
    t108: `Reenviar`,
    t109: `Términos de servicio`,
    t110: `Política de privacidad`,
    t111: `Recuperar contraseña`,
    t112: `Por favor, ingresa la cuenta para la cual deseas recuperar la contraseña`,
    t113: `Nombre de la cuenta`,
    t114: `Introduce tu correo electrónico`,
    t115: `Enviar`,
    t116: `Por favor, ingrese su correo electrónico primero.`,
    t117: `El formato del correo electrónico es incorrecto`,
    t118: `Correo electrónico enviado`,
    t119: `Por favor, revisa tu correo electrónico, haz clic en el enlace y restablece tu contraseña.`,
    t120: `Entendido`,
    t121: `Restablecer contraseña - WeMeet`,
    t122: `Su solicitud de restablecimiento de contraseña ha sido confirmada, y el sistema ha generado un enlace temporal para restablecer la contraseña. Recuerda amablemente: este enlace es válido durante 24 horas, actúe lo antes posible.`,
    t123: `Restablecer contraseña`,
    t124: `Restablecimiento de contraseña exitoso`,
    t125: `Ha ingresado a WeMeet. Bienvenido de vuelta.`,
    t126: `Ir a la página de inicio`,
    t127: `Contactos`,
    t128: `Solicitud de contacto nueva`,
    t129: `Aceptar`,
    t130: `Ignorar`,
    t131: `Aprobado/a`,
    t132: `Ignorado`,
    t133: `Siguiendo`,
    t134: `Seguido/a`,
    t135: `Mensajes`,
    t136: `Solicitud pendiente`,
    t137: `Por favor, ingrese su nombre o número de teléfono`,
    t138: `No se encontró contenido coincidente`,
    t139: `No hay más disponibles`,
    t140: `Solicitud de contacto`,
    t141: `Aceptar`,
    t142: `Ignorar`,
    t143: `Aprobado/a`,
    t144: `Ignorado`,
    t145: `Espacio WeMeet AI`,
    t146: `Siguiendo`,
    t147: `Dejando de seguir`,
    t148: `vCard`,
    t149: `Conectar`,
    t150: `Enviar mensaje`,
    t151: `Pendiente de aprobación`,
    t152: `Quitar contacto`,
    t153: `Presentación personal`,
    t154: `Perfil personal`,
    t155: `Consejos útiles`,
    t156: `Su solicitud de contacto ha sido enviada. Una vez aprobada, comenzarás a seguirlo automáticamente. También puedes optar por seguirlo ahora para obtener más información sobre él/ella.`,
    t157: `No seguir por ahora`,
    t158: `Seguir`,
    t159: `Siguiendo`,
    t160: `Eliminar relación de contacto`,
    t161: `Al eliminar la relación de contacto, la otra persona ya no podrá ver tu información personal, pero no se desuscribirá automáticamente de ti.`,
    t162: `Piénsalo de nuevo`,
    t163: `Quitar contacto`,
    t164: `Operación exitosa`,
    t165: `Asistente IA de WeMeet`,
    t166: `Por favor ingrese su pregunta`,
    t167: `Enviar`,
    t168: `Tenga en cuenta que el contenido de interacción con la IA puede ser inexacto y no representa la perspectiva de la plataforma.`,
    t169: `Tarjeta de presentación de WeMeet`,
    t170: `Descargar`,
    t171: `Editar tarjeta de presentación`,
    t172: `Descargar código QR`,
    t173: `La imagen ha sido generada. Por favor, guárdela. Escanee el código QR para guardar el contacto.`,
    t174: `Foto de perfil`,
    t175: `Por favor, sube una foto de perfil real`,
    t176: `Nombre completo`,
    t177: `Nombre`,
    t178: `Apellido`,
    t179: `Por favor ingrese su nombre`,
    t180: `Nombre de la organización`,
    t181: `Por favor, indique el nombre de su organización`,
    t182: `Cargo`,
    t183: `Por favor, indique el título de su cargo dentro de la organización`,
    t184: `Correo electrónico`,
    t185: `Introduce tu correo electrónico`,
    t186: `Número de teléfono móvil`,
    t187: `Por favor, ingrese su número de teléfono móvil`,
    t188: `Región`,
    t189: `Por favor, seleccione una región`,
    t190: `Zona`,
    t191: `Por favor, seleccione provincia, ciudad y distrito`,
    t192: `Dirección`,
    t193: `Por favor, indique su dirección`,
    t194: `Por favor, indique su nombre`,
    t195: `Por favor, rellena tu apellido`,
    t196: `Por favor, rellena tu correo electrónico primero`,
    t197: `Por favor, rellena el nombre de tu organización primero`,
    t198: `El formato del correo electrónico es incorrecto`,
    t199: `Sala de chat`,
    t200: `Galería de fotos`,
    t201: `Tomar una foto`,
    t202: `Por favor ingrese su mensaje`,
    t203: `Enviar`,
    t204: `Leído`,
    t205: `No leído`,
    t206: `Tiempo límite para retractar vencido`,
    t207: `Cancelar`,
    t208: `Foto`,
    t209: `Álbum`,
    t210: `Tomar foto`,
    t211: `Seleccionar desde el álbum`,
    t212: `Cancelar`,
    t213: `Foto`,
    t214: `Retrato`,
    t215: `Vista previa`,
    t216: `Completar`,
    t217: `Espacio WeMeet AI`,
    t218: `Contáctenos`,
    t219: `Contácteme`,
    t220: `Nombre completo`,
    t221: `Organización`,
    t222: `Posición`,
    t223: `Teléfono`,
    t224: `Correo electrónico`,
    t225: `Región`,
    t226: `Zona`,
    t227: `Dirección`,
    t228: `Por favor, ingrese su nombre`,
    t229: `Por favor, escriba el nombre de su organización`,
    t230: `Por favor, indique su cargo`,
    t231: `Por favor, introduzca su número de teléfono`,
    t232: `Por favor, escriba su dirección de correo electrónico`,
    t233: `Por favor, seleccione una región`,
    t234: `Por favor, seleccione provincia, ciudad y distrito`,
    t235: `Por favor, introduzca una dirección`,
    t236: `Intención`,
    t237: `Comprar productos`,
    t238: `Productos de agente`,
    t239: `Colaboración en el mercado`,
    t240: `Otro`,
    t241: `Por favor, ingrese su nombre`,
    t242: `Por favor, escriba el nombre de su organización`,
    t243: `Por favor, escriba su dirección de correo electrónico`,
    t244: `El formato del correo electrónico es incorrecto`,
    t245: `Mensaje enviado`,
    t246: `Dejar un mensaje`,
    t247: `Por favor, ingrese el contenido de su consulta`,
    t248: `Confirmar`,
    t249: `Por favor, inicie sesión o regístrese primero`,
    t250: `Seguidores`,
    t251: `Contáctenos`,
    t252: `Productos`,
    t253: `Equipo`,
    t254: `Presentación general`,
    t255: `Álbum`,
    t256: `Calificación`,
    t257: `Capital social`,
    t258: `Fecha de fundación`,
    t259: `Dirección registrada`,
    t260: `Upstream`,
    t261: `Midstream`,
    t262: `Downstream`,
    t263: `関連産業`,
    t264: `Process`,
    t265: `Guardar`,
    t266: `Verificado`,
    t267: `Chino`,
    t268: `Inglés`,
    t269: `Francés`,
    t270: `Ruso`,
    t271: `Español`,
    t272: `Japonés`,
    t273: `Coreano`,
    t274: `Indonesio`,
    t275: `Vietnamita`,
    t276: `Alemán`,
    t277: `Turco`,
    t278: `Italiano`,
    t279: `Portugués`,
    t280: `Tailandés`,
    t281: `Malayo`,
    t282: `Árabe`,
    t283: `Nombre de usuario o contraseña incorrectos`,
    t284: `Por favor, lea y acepte primero los Términos de uso de WeMeet`,
    t285: `No hay contenido relevante disponible`,
    t286: `Tipo`,
    t287: `Atributo`,
    t288: `Detalles`,
    t289: `Otro`,
    t290: `En total 2 productos`,
    t291: `{1} te invita a visitar el WeMeet AI Space de {2}`,
    t292: `Haga clic aquí para ver un ejemplo o ingrese una pregunta:`,
    t293: `Actualizar`,
    t294: `También puedes hacer clic en la tarjeta de visita de abajo para agregar contactos y obtener más información:`,
    t295: `Aprender`,
    t296: `Reuniones digitales WeMeet`,
    t297: `Exposiciones digitales WeMeet`,
    t298: `Визитка и Пространство WeMeet AI`,
    t299: `Cómo ser miembro de una organización WeMeet`,
    t300: `WeMeet Servicio de Conferencias Digitales le proporciona una solución completa para reuniones en línea, que incluye, entre otras cosas, la creación y publicación de reuniones, la gestión de registros de participantes, el registro electrónico, la programación de reuniones, el intercambio de materiales de reuniones, discusiones interactivas en tiempo real e interacciones con invitados.`,
    t301: `WeMeet Exposición Digital, ayudando a construir rápidamente un micrositio web oficial de la exposición. Mostrar información de los expositores, descripciones de los productos, transmisiones en vivo de la exposición, registro en la exposición, horarios de eventos, y más, permitiendo a las empresas participantes y al público comprender fácilmente los detalles de la exposición. Para utilizar la función de WeMeet Exposición Digital, primero complete el proceso de ingreso institucional. Haga clic en "Mi", desplácese hacia abajo hasta "Centro de Servicio" - "Ingreso Institucional" y siga las indicaciones para completar el proceso de ingreso.`,
    t302: `Los usuarios personales de WeMeet solo necesitan autorizar su ID de WeChat, número de teléfono y completar el registro en la plataforma para obtener una tarjeta de visita digital personal y mantener su Salón AI personal (que incluye currículum personal, actualizaciones, fotos, documentos, etc.).`,
    t303: `Haga clic en la opción "Mi" en la barra de menú inferior del mini-programa para actualizar la página de la tarjeta de visita personal y mejorar la página de inicio personal.`,
    t304: `Combinación de letras mayúsculas y minúsculas, números y signos de puntuación, con una longitud de entre 8 y 20 caracteres.`,
    t305: `Ingrese el nombre del producto`,
    t306: `No hay más`,
    t307: `Haga clic en la esquina superior derecha`,
    t308: `Seleccione la forma de compartir que prefiera`,
    t309: `Entiendo`,
    t310: `Por favor, complete el registro e inicio de sesión primero`,
    t311: `Obtener más información`,
    t312: `Productos relacionados`,
    t313: `Gracias por su visita`,
    t314: `Cerrar sesión`,
    t315: `Organización seguida`,
    t316: `Anterior`,
    t317: `Siguiente`,
    t318: `Ninguno`,
    t319: `{1} te invita a visitar {2}`,
    t320: `AI Lounge no ha mantenido el idioma actual`,
    t321: `AI Lounge se ha cambiado al idioma actual`,
    t322: `El enlace ha sido activado`,
    t323: `La red está ocupada, por favor inténtelo de nuevo más tarde`,
    t324: `Los detalles del producto se han cambiado al idioma actual`,
    t325: `Los detalles del producto no se mantienen actualmente en este idioma`,
    t326: `¡Hola, soy el asistente de inteligencia artificial WeMeet, listo para brindarle un servicio atento en todo momento! ¿En qué puedo ayudarte?`,
    t327: `Introduzca el nombre`,
    t328: `He encontrado la información de contacto relevante, por favor revise la tarjeta de contacto a continuación.`,
    t329: `Adjunto`,
    t330: `No he encontrado la información de contacto relevante.`,
    t331: `He reenviado su consulta al colega responsable a continuación; también puede hacer clic en la tarjeta de visita para contactar de inmediato.`,
    t332: `Exposición`,
    t333: `Por favor`,
    t334: `Usuario`,
    t335: `No hay más`,
    t336: `Actualización exitosa`,
    t337: `Cargando`,
    t338: `Liberar para refrescar`,
  },
};
